export const UI = () => {
  // Center images in tumblr imported posts
  if ($('.rte').length > 0 ) {
    $('.rte p').find('img').closest('p').addClass('thumbnail-container');
  }  
};